<template>
    <b-row class="summary no-gutters">

        <b-col class="tool-border" cols="12">
            <tedtfHeader :image="'summary'" :screenTitle="'Summary and Next Steps'"></tedtfHeader>
            <b-col class="page-background-gradient reduce-padding" cols="12">
                <b-row class="page-content no-gutters">
                    <div class="body-sec">

                        <b-col class="reduce-padding" cols="12">
                            <div class="main-text">
                                <p>You’ve experienced the following triggers for a TED flare:</p>
                            </div>
                        </b-col>

                        <b-col class="reduce-padding" cols="12">
                            <b-row class="no-gutters">
                                <b-col class="reduce-padding" cols="12">
                                    <b-row class="no-gutters">
                                        <div class="div-sm">
                                            <div class="section-block">

                                                <section data-field="box-image" v-if="userData.smoke == 'smokeYes'">
                                                    <div class="smoke-small-img"></div>
                                                    <div class="img-heading">Smoking</div>
                                                </section>

                                                <!--<div class="extra-marg">-->
                                                    <section data-field="box-image " v-if="userData.givenBirth == 'givenBirthYes'">
                                                        <div class="birth-small-img"></div>
                                                        <div class="img-heading">Pregnancy</div>
                                                    </section>
                                                <!--</div>-->

                                                <div class="extra-marg">
                                                    <section data-field="box-image extra-marg" v-if="userData.radioActiveIodine == 'radioActiveIodineYes'">
                                                        <div class="medicine-small-img"></div>
                                                        <div class="img-heading">RAI<br>Treatment</div>
                                                    </section>
                                                </div>

                                                <div class="extra-marg">
                                                <section data-field="box-image" v-if="userData.eyeTrauma == 'eyeTraumaYes'">
                                                    <div class="taruma-small-img"></div>
                                                    <div class="img-heading">Eye<br>Trauma</div>
                                                </section>
                                                </div>

                                                <section data-field="box-image" v-if="userData.genderMale == 'genderMaleYes'">
                                                    <div class="male-small-img"></div>
                                                    <div class="img-heading">Female</div>
                                                </section>


                                                <!--<div class="extra-marg">-->

                                                    <section data-field="box-image extra-marg" v-if="userData.age40 == 'age40Yes'">
                                                        <div class="couple-small-img"></div>
                                                        <div class="img-heading">Stress</div>
                                                    </section>
                                                <!--</div>-->

                                                <div class="extra-marg">
                                                    <section data-field="box-image extra-marg" v-if="userData.conditions == 'conditionsYes'">
                                                        <div class="key-small-img"></div>
                                                        <div class="img-heading">Autoimmune<br>Condition</div>
                                                    </section>
                                                </div>
                                                
                                                <div class="extra-marg">

                                                    <section data-field="box-image extra-marg" v-if=" userData.covidVaccination == 'covidVaccinationYes'">
                                                        <div class="stress-img"></div>
                                                        <div class="img-heading">Steroid<br>Treatment</div>
                                                    </section>
                                                </div>



                                            </div>
                                        </div>


                                        <div class="all-img-sec div-lg">

                                            <div class="img-sec" v-if="userData.smoke == 'smokeYes'">
                                                <div class="smoke-small-img"></div>
                                                <div class="img-heading1">Smoking</div>
                                            </div>



                                            <div class="img-sec" v-if="userData.givenBirth == 'givenBirthYes'">
                                                <div class="birth-small-img"></div>
                                                <div class="img-heading">Pregnancy</div>
                                            </div>



                                            <div class="img-sec" v-if="userData.radioActiveIodine == 'radioActiveIodineYes'">
                                                <div class="medicine-small-img"></div>
                                                <div class="img-heading">RAI<br>Treatment</div>
                                            </div>



                                            <div class="img-sec" v-if="userData.eyeTrauma == 'eyeTraumaYes'">
                                                <div class="taruma-small-img"></div>
                                                <div class="img-heading">Eye<br>Trauma</div>
                                            </div>



                                            <div class="img-sec" v-if="userData.genderMale == 'genderMaleYes'">
                                                <div class="male-small-img"></div>
                                                <div class="img-heading">Female</div>
                                            </div>



                                            <div class="img-sec" v-if="userData.age40 == 'age40Yes'">
                                                <div class="couple-small-img"></div>
                                                <div class="img-heading">Stress</div>
                                            </div>



                                            <div class="img-sec" v-if="userData.conditions == 'conditionsYes'">
                                                <div class="key-small-img"></div>
                                                <div class="img-heading">Autoimmune<br>Condition</div>
                                            </div>

                                            <div class="img-sec" v-if="userData.covidVaccination == 'covidVaccinationYes'">
                                                <div class="stress-img"></div>
                                                <div class="img-heading">Steroid<br>Treatment</div>
                                            </div>

                                        </div>
                                    </b-row>
                                </b-col>
                                <b-col class="reduce-padding" cols="12">
                                    <b-row class="no-gutters grey-box">
                                        <b-col class="reduce-padding" lg="6" md="6" cols="12">

                                            <b-row class="no-gutters ted-treatment">
                                                <div class="reduce-padding pdf-img" v-if="(!generatingPdf) && (!pdfReady)" @click="generatePdf(userData)"></div>
                                                <div class="reduce-padding pdf-img disable-icon" v-if="generatingPdf"></div>
                                                <div class="reduce-padding pdf-img" v-if="pdfReady && !generatingPdf" @click="downloadaPdf()"></div>
                                                <div class="pdf-text" cols="12" md="10" v-if="(!generatingPdf) && (!pdfReady)" @click="generatePdf(userData)">
                                                    Download your results and share them with your doctor.
                                                </div>
                                                <div class="pdf-text2" :class="{'disable-icon':generatingPdf}" v-if="generatingPdf || pdfReady">
                                                    <b-button class="pdf-button spinner-btn" v-if="generatingPdf" disabled>
                                                        <b-spinner></b-spinner> Generating Report...
                                                    </b-button>
                                                    <button class="pdf-button" v-if="pdfReady && !generatingPdf" @click="downloadaPdf()">
                                                        <u>PDF is ready! Click to download.</u>
                                                    </button>
                                                </div>
                                                <hr class="horizontal-line sm-screen lg-screen">
                                                <div class="v1">
                                                    <div class="vertical-line"></div>
                                                </div>
                                            </b-row>



                                        </b-col>

                                        <b-col class="reduce-padding" lg="6" md="6" cols="12">
                                            <b-row class="no-gutters ted-treatment">
                                                <a href="https://www.thyroideyes.com/thyroid-eye-disease-treatment/" @click="tagLink"  target="_blank">
                                                    <div class="circle-img"></div>
                                                </a>


                                                <div class="circle-text"> <a href="https://www.thyroideyes.com/thyroid-eye-disease-treatment/" @click="tagLink"  target="_blank">Learn your TED treatment options here. </a></div>

                                            </b-row>
                                        </b-col>



                                    </b-row>
                                    <b-row class="container no-gutters">
                                        <div class="container-box">
                                            <div class="text">
                                                <div class="container-text">Share a link to this tool.</div>
                                                <div class="simple-text">(Your results will not be shared.)</div>
                                            </div>
                                            <div class="icons-img">
                                                <div class="facebook-icon" @click="facebook()"></div>
                                                <div class="twitter-icon" @click="twitter()"></div>
                                                <div class="envelope-icon" @click="email()"></div>
                                            </div>
                                        </div>


                                    </b-row>

                                    <div class="footer-text">
                                        ©2022 Horizon Therapeutics plc DA-UNBR-US-00792-2 09/22
                                    </div>

                                </b-col>

                            </b-row>
                        </b-col>

                    </div>
                </b-row>
            </b-col>

            <tedftNavigation v-bind:navButtons="['back', 'showMidCol', 'showspecialist']" :currentScreen="9" :isSymptom="true" :showspecialist="true" :isHideMenu="false"></tedftNavigation>

        </b-col>

    </b-row>
</template>
<script>
    /* eslint-disable */
    import tedtfHeader from '../components/tedtfHeader.vue';
    import tedftNavigation from '../components/tedftNavigation.vue';
    import { mapGetters, mapMutations } from 'vuex';
    import LZString from 'lz-string';
    import axios from 'axios';

    export default {
        name: "summary",
        mounted: function() {},
        components: {
            'tedtfHeader': tedtfHeader,
            'tedftNavigation': tedftNavigation,
        },

        computed: {
            ...mapGetters('userData', ['userData'])
        },

        methods: {

            facebook: function() {
                var root = 'https://www.facebook.com/sharer/sharer.php';
                var link = (this.socialurl !== null) ? this.socialurl : window.parent.location;
                var target = '_blank';
                var url = root +
                    '?u=' + encodeURIComponent(link) +
                    '&display=popup' +
                    '&ref=plugin' +
                    '&src=share_button';
                var params = 'width=' + 600 + ', height=' + 450;
                window.open(url, target, params);

                var obj = {
                    hitType: 'event',
                    eventCategory: 'TED Tool Link Share',
                    eventAction: "TED Tool Link Share Via Facebook",
                };
                try {
                    console.log("sending Message:", JSON.stringify(obj));
                    window.top.postMessage(JSON.stringify(obj), "*");
                }
                catch (e) {
                    console.log("error sending Message");
                }

            },

            twitter: function() {
                var root = 'https://twitter.com/share';
                var link = this.socialurl;
                var text = 'Are you experiencing Thyroid Eye Disease (TED) “flares”, or symptoms that worsen/intensify? Learn about what may be causing your symptoms to worsen with the TED Triggers and Flares tool.';
                var hashtag = '#ListenToYourEyes';
                var target = '_blank';

                var url = root +
                    '?url=' + encodeURIComponent(link) +
                    '&text=' + encodeURIComponent(text) + '%0a' + encodeURIComponent(hashtag) +
                    '&related=yarrcat';

                var params = 'width=' + 600 + ', height=' + 450;
                window.open(url, target, params);

                var obj = {
                    hitType: 'event',
                    eventCategory: 'TED Symptoms Link Share',
                    eventAction: "TED Symptoms Link Share Via Twitter",
                };
                try {
                    console.log("sending Message:", JSON.stringify(obj));
                    window.top.postMessage(JSON.stringify(obj), "*");
                }
                catch (e) {
                    console.log("error sending Message");
                }
            },

            email: function() {
                var obj={ 
                    hitType: 'event',
                    eventCategory: 'TED Triggers & Flares Navigation',
                    eventAction: 'Email Icon Click',
                    eventLabel: 'Summary Screen',
                };
                try {
                console.log("sending Message:", JSON.stringify(obj));
                window.top.postMessage(JSON.stringify(obj), "*");
                } catch(e) {
                console.log("error sending Message");
                }
                this.$router.push('email');
            },
            generatePdf: function(userData) {
                this.generatingPdf = true;
                const config = this.$config.config;

                const data = LZString.compressToEncodedURIComponent(JSON.stringify(userData));

                // if a URL was given in the config use that otherwise create it based on the current location
                var reportUrl = '';
                if (this.$config.reportUrl !== undefined) {
                    reportUrl = '{0}#?u={1}'.format(this.$config.reportUrl);
                }
                else {
                    const url = window.location.href;
                    const parts = url.split('://');
                    const schema = parts[0]
                    const uri = parts[1]
                        .replace(/#.*$/, '')
                        .replace(/\/[^\/]*$/, '');
                    reportUrl = `${schema}://${uri}/report.html#?u=${data}`;
                }
                console.log(reportUrl);

                const renderConfig = {
                    url: reportUrl,
                    version: "2.1.1",
                    resourceWait: 3000,
                    timeout: 15000,
                    viewportSize: {
                        width: 615,
                        height: 600
                    },
                    paperSize: {
                        named: {
                            orientation: 'portrait',
                            margin: { value: 0 }
                        }
                    },
                    zoomFactor: 0

                };

                axios.post(`${config.serviceUrl}/render/v1/pdf?app_id=${config.apiKey}`, renderConfig)
                    .then((response) => {
                        this.generatingPdf = false;
                        this.pdfReady = true;
                        this.key = response.data.key;

                    })
                    .catch((error) => {
                        this.generatingPdf = false;
                        alert(`Error generating PDF. ${error}`)
                    });
            },
            downloadaPdf: function() {

                this.pdfReady = false;
                const config = this.$config.config;
                window.open(
                    `${config.serviceUrl}/render/v1/pdf/download/report.pdf?app_id=${config.apiKey}&id=${this.key}`,
                    '_blank');
                // tag for pdf download
                var obj={ 
                 hitType: 'event',
                  eventCategory: 'T1 Action',
                  eventAction: "T1A",
                  eventLabel: "Triggers and Flares (downloads)"
                };
                try {
                  console.log("sending Message:", JSON.stringify(obj));
                  window.top.postMessage(JSON.stringify(obj), "*");
                } catch(e) {
                  console.log("error sending Message");
                }
            },
            
            tagLink: function() {
                var obj={ 
                hitType: 'event',
                eventCategory: 'TED External Link',
                eventAction: 'Learn your TED treatment options here',
                eventLabel: 'https://www.thyroideyes.com/thyroid-eye-disease-treatment/'
                };
                try {
                  console.log("sending Message:", JSON.stringify(obj));
                  window.top.postMessage(JSON.stringify(obj), "*");
                } catch(e) {
                  console.log("error sending Message");
                }
            },
        },

        data() {
            return {
                socialurl: 'ThyroidEyes.com',
                generatingPdf: false,
                pdfReady: false,
            };
        },
    };
</script>


<style lang="scss" scoped>
</style>
